import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=79220c6a&"
import script from "./announcement.vue?vue&type=script&lang=js&"
export * from "./announcement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79220c6a')) {
      api.createRecord('79220c6a', component.options)
    } else {
      api.reload('79220c6a', component.options)
    }
    module.hot.accept("./announcement.vue?vue&type=template&id=79220c6a&", function () {
      api.rerender('79220c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/announcement.vue"
export default component.exports